import myAxios from '@/utils/MyAxios';

const failResult = (error) => ({
    data: {
        success: false,
        code: -1,
        message: error?.message || 'Network Error',
        data: { rows: [], totalPage: 0, totalRows: 0 }
    },
    status: 0
});

const myRequest = {
    get(url, params){
        const config= {
            method: 'get',
            url: url
        }
        if(params) config.params = params;
        return myAxios(config).catch(failResult);
    },
    post(url, params){
        const config= {
            method: 'post',
            url: url,
        }
        if( params ) {
            config.data = params;
        }
        return myAxios(config).catch(failResult);
    },
    put(url, params){
        const config= {
            method: 'put',
            url: url
        }
        if(params) config.params = params;
        return myAxios(config).catch(failResult);
    },
    delete(url, params){
        const config= {
            method: 'delete',
            url: url
        }
        if(params) config.params = params;
        return myAxios(config).catch(failResult);
    }
}

export default myRequest
